/**
 * Where a suggested fix's chip goes. kim-ai-backend resolves each target to a page kind and id
 * (`GapFixTargetLink`); this maps that to the app's route.
 */

import type { GapFixTargetLink, GapSuggestedFix } from './types';

/** The persona page's search param that opens one persona's details. */
export const PERSONA_SEARCH_PARAM = 'persona';

/** The persona param's value for the brand's own persona ("My Brand"), one per brand. */
export const BRAND_PERSONA = 'brand';

/**
 * Where a fix's chip goes: the target the backend resolved, else, for a persona fix that names
 * no persona, the brand's persona — a persona fix is about the brand's voice.
 */
export function fixTargetLink(fix: Pick<GapSuggestedFix, 'targetType' | 'targetLink'>): GapFixTargetLink | null {
  if (fix.targetLink) return fix.targetLink;
  if (fix.targetType === 'persona') return { kind: 'persona', id: BRAND_PERSONA };
  return null;
}

/** The app route a linked fix target opens. A persona opens on the persona page, its details shown. */
export function fixTargetHref(link: GapFixTargetLink): string {
  const id = encodeURIComponent(link.id);
  switch (link.kind) {
    case 'protocol':
      return `/training/protocols/${id}`;
    case 'sop':
      return `/sops/${id}`;
    case 'source':
      return `/training/sources/${id}`;
    case 'persona':
      return `/training/persona?${PERSONA_SEARCH_PARAM}=${id}`;
  }
}
